<div class="row justify-content-center g-0">
    <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">

        <div class="d-flex justify-content-between">
            <h1>
                <fa-icon class="mx-1" [icon]="faCalendarAlt"></fa-icon>
                <span>programma</span>
            </h1>

            @if(!processing()) {
                @let tmplCurrentGameRound = currentGameRound();
                @if(pool && poolUsers && tmplCurrentGameRound){
                    <app-schedule-gameround-scroller   
                        [viewPeriod]="tmplCurrentGameRound.viewPeriod"
                        [gameRounds]="viewGameRounds()"
                        [activeGameRound]="tmplCurrentGameRound"
                        [previousGameRound]="previousGameRound()"
                        [nextGameRound]="nextGameRound()"
                        (previousPressed)="selectPreviousGameRound(pool.getCompetitionConfig(), tmplCurrentGameRound)"
                        (nextPressed)="selectNextGameRound(pool.getCompetitionConfig(), tmplCurrentGameRound)"         
                    ></app-schedule-gameround-scroller>
                }
            }
        </div>
        
        <!-- <div [ngbNavOutlet]="nav" class="mt-2"></div> -->
        
        <!-- <pre>Active: {{ active }}</pre> -->

        @if(!processing()) {

            @let tmplCurrentGameRound = currentGameRound();           
            @if( !processingGames() && !processingStatistics()) {
                @if(pool && poolUsers && tmplCurrentGameRound && sourceGameRoundGames.length > 0 && competitorPoolUserAndFormations()){                    
                    <div class="mt-3">                
                        <againstgames-table
                        [sourceAgainstGames]="sourceGameRoundGames"
                        [gameRound]="tmplCurrentGameRound"
                        [competitorPoolUserAndFormations]="competitorPoolUserAndFormations()"
                        [statisticsGetter]="statisticsGetter"
                        [comparisonPoolUser]="poolUserFromSession"
                        [selectedPoolUser]="comparedPoolUser()"
                        (poolUserSelected)="compareWithPoolUser($event)">
                        </againstgames-table>
                    </div>
                }
            } @else {
                <h2 class="text-center">
                    <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
                </h2>
            }
            @if(pool){                
                <app-pool-navbar [current]="Schedule" [pool]="pool" [poolUser]="poolUserFromSession">
                </app-pool-navbar>                
            }
        } @else {
            <h2 class="text-center">
                <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
            </h2>
        }
    </div>
</div>